import { formatDateForMcleod } from "../utils/dateHelpers";

export default class CallInSerializer {  

  static serialize(data) {
    const payload = {
      ...data,
      __type: data.__type,
      company_id: data.company_id,
      call_date_time: formatDateForMcleod(data.call_date_time),
      callin_status: data.callin_status,
      city_id: parseInt(data.city_id),
      city_name: data.city_name,
      current_stop_id: data.current_stop_id,
      entered_by: data.entered_by,
      initiated_type: data.initiated_type,
      latitude: parseInt(data.latitude),
      longitude: parseInt(data.longitude),
      miles2consignee: parseInt(data.miles2consignee),
      movement_id: data.movement_id,
      movement_status: data.movement_status,
      new_eta: data.new_eta !== null ? formatDateForMcleod(data.new_eta) : null,
      next_stop_city_id: parseInt(data.next_stop_city_id),
      next_stop_city_name: data.next_stop_city_name,
      next_stop_state: data.next_stop_state,
      next_stop_zip_code: data.next_stop_zip_code,
      order_id: data.order_id,
      payee_id: data.payee_id,
      remark: data.remark,
      state: data.state,
      zip_code: data.zip_code
    };
    
    return payload;
  } 
  
}